<template>
  <div id="FacilitySelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">施設選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>施設名</th><td><input v-model="searchConditions.institutionName" type="text" /></td>
              <th>郵便番号</th><td><input v-model="searchConditions.postcode" type="text" /></td>
              <th>都道府県</th><td>
                <select v-model="searchConditions.prefecture">
                  <option value=""></option><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
              </select></td>
              <th>担当支店</th><td>
                <select v-model="searchConditions.branchOfficeCode">
                  <option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
              </select></td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="hasResult"
            id="facilitySelectTable"
            :data="data"
            paginated
            per-page="10"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
                <b-table-column field="customerId" label="" width="20" centered>
                    <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
                </b-table-column>
                <b-table-column field="施設名" label="施設名" width="200">{{props.row.orgName}}</b-table-column>
                <b-table-column field="担当支店" label="担当支店" width="100">{{props.row.branchOfficeName}}</b-table-column>
                <b-table-column field="郵便番号" label="郵便番号" width="100" centered>{{props.row.postcode}}</b-table-column>
                <b-table-column field="住所" label="住所">{{props.row.prefecture}}{{props.row.address}}{{props.row.houseNumber}}{{props.row.building}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
      <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
      <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "FacilitySelectModal",
  props: ["searchId"],
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      this.hasResult = false;
      this.selectedItem = null;
      let _this = this;
      let obj = JSON.parse(JSON.stringify(this.searchConditions));
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getFacilityListPOST({
            body:obj
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
          _this.hasResult = true;
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },
  },
  data() {
    var branchList = this.getBranchOfficeMaster();
    branchList.unshift({});
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var belongsId = this.$props.searchId;
    return {
      data: [],
      searchConditions:{
        dealerId: !belongsId ? userInfo.belongsId : belongsId,
        institutionName:"",
        postcode:"",
        prefecture:"",
        branchOfficeCode:""
      },
      branchList,
      selectedItem:'',
      hasResult: false
    };
  },
  filters: {},
  components: {},
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/FacilitySelectModal.vue